
import axios from 'axios'
import Qs from 'qs'

const baseUrl = '/guanglian'
// const baseUrl = '/guanglian1'

// 监测监护内容字典表接口
export const queryMonitorGuardInfoByType = params => { return axios.get(`${baseUrl}/departdictMonitorGuard/queryMonitorGuardInfoByType/${params}`) }

// 用户详情
export const getUserList = params => { return axios.post(`${baseUrl}/user/getUserList`, {params}) }

// 告警数据
export const getTop = params => { return axios.get(`${baseUrl}/warningInfo/getTop`, {params}) }
// 数据列表
export const getWarringInfo = params => { return axios.get(`${baseUrl}/warningInfo/getWarringInfo`,{params}) }
// 在线数量离线数量
export const getEqu = params => { return axios.get(`${baseUrl}/equipment/getEqu`,{params}) }

// 自动化设备模板下载 (excel)
export const equipmentDownload = params => {
  return axios({
    responseType: 'blob',
    method: 'get',
    url: `${baseUrl}/equipment/download`,
    params,
  })
}